"use client";

import useHash from "@packages/hooks/DetectHashChange";
import React from "react";


const RecommendedUnisButton = ({ btnSize = "w-full", defaultFragmentId }: { btnSize?: string, defaultFragmentId?: string }) => {

  const [activeHash] = useHash();

  function scrollTo(elementId: string) {
    document.getElementById(elementId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };

  const handleRecommendedUni = async (e: any) => {
    e.stopPropagation();
    e.preventDefault();

    scrollTo((activeHash ? activeHash : defaultFragmentId) + "similar-unis");
  };

  return (
    <button type="button" className={`btn btn-white border border-primary-400 ${btnSize}`}
      onClick={handleRecommendedUni}>
      Recommended unis
    </button>
  );
};

export default RecommendedUnisButton;
